import React from "react";
import "./Scene.css";
import Row from "react-bootstrap/Row";
import Card from 'react-bootstrap/Card';
import iconMS from "../../../TestApp/assets/img/devices/MS.png";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlay} from "@fortawesome/free-solid-svg-icons";


function Scene({bond, sceneId, sceneData}) {
    return (<Row className="deviceRow">
        <Card className={"deviceCard"}>
            <Card.Body>
                <Card.Title>
                    <img className={'deviceTypeIcon'} src={iconMS}
                         alt={sceneData.name}/>
                    {sceneData.name}
                    <Button className={"appSceneRunBtn"} variant={"outline-success"}>
                        <FontAwesomeIcon icon={faPlay} size="xl" className=""/>
                    </Button>
                </Card.Title>
            </Card.Body>
        </Card>
    </Row>);
}

export default Scene;
